/* eslint-disable */
export default {
  _pop2: 'pop2',
  _pop1: 'pop1',
  _click: 'click',
}